import { combineReducers } from 'redux';
import { inquiryDetail } from './InquiryDetail';

export const inquiry = combineReducers({
    inquiryDetail,
})